import WriteTodoWordArea from "@/pages/comp/plan/todo/common/write_todo_word";

function WriteTodoWordPopup(props: any) {
  let myProps = {
    closePopup: () => { },
    callbackData: (inData: any) => { },
    ...props
  };

  return (
    <div>
      <WriteTodoWordArea
        closePopup={myProps.closePopup}
        callbackData={myProps.callbackData}
      ></WriteTodoWordArea>
    </div>
  );
};
export default WriteTodoWordPopup;